import { EMAIL, DEFAULT_PHONE, formatPhoneNumber } from '@belong/common';

// We decided with Lily to go with a single default for all regions for both AEs and Res Growth.
export const getDefaultHomeownerGrowth = () => {
  return {
    employee: {
      quote: '"Life has no limitations, except the ones you make."',
      bannerImage:
        'https://s3-us-west-1.amazonaws.com/bln-prd-employee-banner-images/322718-502154547243da2b',
      phone: { link: DEFAULT_PHONE, display: formatPhoneNumber(DEFAULT_PHONE) },
      email: EMAIL,
    },
    employeeAssignment: {
      assignmentType: 'HomeownerGrowth',
      sourceType: 'Home',
    },
    user: {
      firstName: 'Nicolas',
      lastName: 'Vurgait',
      memberSince: '2025-02-10T17:01:02+00:00',
      name: 'Nicolas Vurgait',
      profileImageUrl:
        'https://s3-us-west-1.amazonaws.com/bln-prd-usr-pics/322718-dad9f77c5e36e8f8',
      userId: 'd4922a6e3801d9ac',
      aboutMe: `Before joining Belong, I managed multiple successful Airbnb properties and co-founded a tech startup, gaining hands-on experience in both hospitality and innovation. With a background in finance, I bring a deep understanding of the financial landscape that supports smart, sustainable homeownership decisions.`,
      homeTown: 'Miami',
    },
  };
};
